import { render, staticRenderFns } from "./DispatchTripTasks.vue?vue&type=template&id=14bfa94c&scoped=true&"
import script from "./DispatchTripTasks.vue?vue&type=script&lang=js&"
export * from "./DispatchTripTasks.vue?vue&type=script&lang=js&"
import style0 from "./DispatchTripTasks.vue?vue&type=style&index=0&id=14bfa94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bfa94c",
  null
  
)

export default component.exports